// extracted by mini-css-extract-plugin
export default {"radioSpan":"radio-span_radioSpan__CtVtt"};